import { render, staticRenderFns } from "./DataSelector.vue?vue&type=template&id=7ca4ee6a&"
import script from "./DataSelector.vue?vue&type=script&lang=js&"
export * from "./DataSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports